const initMobileHoverRuntime = () => {
  if (window.__waldMobileHoverInitialized) return;
  window.__waldMobileHoverInitialized = true;

  const activateMoodVideo = (video) => {
    if (!video) return;

    const card = video.closest('.card-mood__inner--video');
    if (card) card.classList.add('card-mood__inner--video-active');

    // Match video-with-text behavior: restart from 0, enable sound, and open fullscreen on click.
    video.pause();
    try {
      video.currentTime = 0;
    } catch (_) {}
    video.loop = false;
    video.removeAttribute('loop');
    video.controls = true;
    video.setAttribute('controls', 'controls');
    video.muted = false;
    video.defaultMuted = false;
    video.removeAttribute('muted');
    if (typeof video.volume === 'number') video.volume = 1;

    const playWithCatch = () => {
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };
    const playFromStartWithCatch = () => {
      try {
        video.currentTime = 0;
      } catch (_) {}
      playWithCatch();
    };

    try {
      if (typeof video.requestFullscreen === 'function') {
        const fullscreenPromise = video.requestFullscreen();
        if (fullscreenPromise && typeof fullscreenPromise.catch === 'function') {
          fullscreenPromise.catch(() => {});
        }
        if (fullscreenPromise && typeof fullscreenPromise.then === 'function') {
          fullscreenPromise.then(playWithCatch).catch(() => {});
        }
      } else if (typeof video.webkitEnterFullscreen === 'function') {
        video.webkitEnterFullscreen();
      } else if (typeof video.webkitRequestFullscreen === 'function') {
        video.webkitRequestFullscreen();
      }
    } catch (_) {
      // Ignore unsupported fullscreen errors.
    }

    // iOS Safari can pause during fullscreen transition; enforce play afterwards.
    video.addEventListener('webkitbeginfullscreen', playFromStartWithCatch, { once: true });
    window.setTimeout(playFromStartWithCatch, 120);
    playWithCatch();
  };

  document.addEventListener('click', (event) => {
    const card = event.target.closest('.card-mood__inner--video');
    if (!card || card.classList.contains('card-mood__inner--video-active')) return;

    const video = card.querySelector('video[data-mood-video]');
    if (!video) return;

    event.preventDefault();
    event.stopPropagation();
    activateMoodVideo(video);
  });

  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  if (!isTouchDevice) return;

  const selector = '.card-mood__inner--interactive';
  let activeCard = null;
  let clearTimer = null;

  const clearActive = () => {
    if (clearTimer) {
      clearTimeout(clearTimer);
      clearTimer = null;
    }
    if (activeCard) {
      activeCard.classList.remove('mobile-active');
      activeCard = null;
    }
  };

  document.addEventListener(
    'touchstart',
    (event) => {
      const card = event.target.closest(selector);
      if (!card) return;

      if (clearTimer) {
        clearTimeout(clearTimer);
        clearTimer = null;
      }

      if (activeCard && activeCard !== card) {
        activeCard.classList.remove('mobile-active');
      }

      activeCard = card;
      activeCard.classList.add('mobile-active');
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    (event) => {
      const card = event.target.closest(selector) || activeCard;
      if (!card) return;

      // Small delay to ensure the user sees the change even on quick taps
      clearTimer = setTimeout(() => {
        card.classList.remove('mobile-active');
        if (activeCard === card) activeCard = null;
      }, 150);
    },
    { passive: true }
  );

  document.addEventListener(
    'touchcancel',
    () => {
      clearActive();
    },
    { passive: true }
  );
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMobileHoverRuntime, { once: true });
} else {
  initMobileHoverRuntime();
}
